module.exports = __webpack_public_path__ + "img/KreuzUndSchrift.999e9d9d.png";